export default "__VITE_ASSET__c913fac2__"